import { useState } from 'react';
import PageLayout from '../../components/ui/PageLayout';
import ReportConfigs from './ReportConfigs';
import ReportSchedules from './ReportSchedules';
import DropdownFranchise from '@/components/dropdowns/DropdownFranchise';
import ReportViewer from './ReportViewer';

export default function ReportDashboard(): JSX.Element {
  const [activeTab, setActiveTab] = useState<'reports' | 'schedules' | 'viewer'>('reports');

  return (
    <PageLayout title = "Reporting">
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
            Franchise
          </label>
          <DropdownFranchise />
        </div>
        <div className="bg-white dark:bg-slate-800 rounded-xl shadow p-4">

          <div className="flex space-x-4 border-b border-gray-200 dark:border-gray-700">
            <button
              className={`px-4 py-2 text-sm font-medium ${
                activeTab === 'reports'
                  ? 'border-b-2 border-blue-600 text-blue-600'
                  : 'text-gray-600 dark:text-gray-300'
              }`}
              onClick={() => { setActiveTab('reports'); }}
            >
              Reports
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium ${
                activeTab === 'schedules'
                  ? 'border-b-2 border-blue-600 text-blue-600'
                  : 'text-gray-600 dark:text-gray-300'
              }`}
              onClick={() => { setActiveTab('schedules'); }}
            >
              Schedules
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium ${
              activeTab === 'viewer'
                   ? 'border-b-2 border-blue-600 text-blue-600'
                  : 'text-gray-600 dark:text-gray-300'
              }`}
              onClick={() => { setActiveTab('viewer'); }}
            >
              View Previous Reports
            </button>
          </div>
        </div>
        <div className="mt-4">
          {activeTab === 'reports' && <ReportConfigs />}
          {activeTab === 'schedules' && <ReportSchedules />}
          {activeTab === 'viewer' && <ReportViewer />}
        </div>
      </div>
    </PageLayout>
  );
}
